import React, {useContext, useRef, useState} from 'react';
import Form from "react-bootstrap/Form";
import Icon from "@reacticons/bootstrap-icons";
import {Context} from "../../index";
import classes from "./Autocomplet.module.css";
import {useIntl} from "react-intl";

const ContainerRowOutput = (props) => {
    const {store} = useContext(Context);
    const intl = useIntl();
    const row = props.row;
    const inputRef = useRef(null);
    const [show, setShow] = useState(false);
    const hours = Array.from({length: 24}, (_, hour) => `${String(hour).padStart(2, '0')}:00`);
    const selectedContainer = store.containers.find(container => container.number === row.number);
    const selectedType = store.typeOut.find(type => String(type.id) === String(selectedContainer?.type ?? row.type));
    const typeName = selectedContainer?.type_name ?? selectedType?.name ?? '';
    const selectedContent = selectedContainer?.content ?? row.content;
    const contentName = selectedContent === 'F'
        ? intl.messages.fullc
        : selectedContent === 'E' ? intl.messages.empty : '—';

    const updateNumber = (input, value) => {
        const normalized = value.toUpperCase().trim();
        props.handleChange(normalized, 'number', props.index);

        const container = store.containers.find(item => item.number === normalized && Number(item.is_blocked) !== 1);
        if (container) {
            input.setCustomValidity('');
            setShow(false);
            return;
        }

        input.setCustomValidity(normalized.length === 11
            ? 'Контейнер не найден в текущем стоке или заблокирован'
            : 'Укажите номер контейнера');
        setShow(normalized.length > 0);
    };

    const filteredContainers = store.containers
        .filter(container => Number(container.is_blocked) !== 1)
        .filter(container => container.number?.toLowerCase().includes((row.number ?? '').toLowerCase()))
        .slice(0, 20);

    const selectContainer = (container) => {
        props.handleChange(container.number, 'number', props.index);
        inputRef.current?.setCustomValidity('');
        setShow(false);
    };

    return (
        <tr>
            <td>{props.index + 1}</td>
            <td><Form.Control value={typeName} readOnly tabIndex={-1}/></td>
            <td className={classes.position}>
                <Form.Control
                    ref={inputRef}
                    autoComplete="off"
                    value={row.number ?? ''}
                    onFocus={() => setShow(Boolean(row.number))}
                    onChange={event => updateNumber(event.target, event.target.value)}
                    type="text"
                    maxLength={11}
                    required
                />
                {show && row.number ?
                    <ul className={classes.autocomplet}>
                        {filteredContainers.map(container =>
                            <li
                                key={container.id}
                                className={container.content === 'F' ? `text-danger ${classes.autocomplet__item}` : classes.autocomplet__item}
                                onMouseDown={event => event.preventDefault()}
                                onClick={() => selectContainer(container)}
                            >
                                {container.number}{container.content === 'F' ? ` ${intl.messages.full_container}` : ''}
                            </li>
                        )}
                    </ul> : null
                }
            </td>
            <td><Form.Control value={contentName} readOnly tabIndex={-1}/></td>
            <td>
                <Form.Select value={row.out_time ?? ''} onChange={event => props.handleChange(event.target.value, 'out_time', props.index)} required>
                    <option value="">{intl.messages.choose_out_time}</option>
                    {hours.map(hour => <option key={hour} value={hour}>{hour}</option>)}
                </Form.Select>
            </td>
            <td><Form.Control type="text" value={row.car_number ?? ''} onChange={event => props.handleChange(event.target.value, 'car_number', props.index)}/></td>
            <td><Form.Control type="text" value={row.fio ?? ''} onChange={event => props.handleChange(event.target.value, 'fio', props.index)}/></td>
            <td>
                {row.moving || !props.del ? null :
                    <a href="#" className="text-warning" onClick={event => props.delete(event, props.index)}>
                        <Icon name="trash"/>
                    </a>
                }
            </td>
        </tr>
    );
};

export default ContainerRowOutput;
